
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2 } from "lucide-react";

interface ClaimFormProps {
  onSubmit: (code: string) => void;
  isLoading: boolean;
}

export function ClaimForm({ onSubmit, isLoading }: ClaimFormProps) {
  const [code, setCode] = useState("");

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (code.trim()) {
      onSubmit(code.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-bold">Claim a Voucher</h2>
      
      <div className="flex gap-2">
        <Input
          placeholder="Enter voucher code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="flex-1 bg-gray-900 border-gray-700 text-[#FFFCF3] placeholder:text-gray-500"
          disabled={isLoading}
        />
        
        <Button 
          type="submit" 
          disabled={!code.trim() || isLoading}
          className="bg-[#089BDF] hover:bg-[#089BDF]/90 text-white"
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            "Claim"
          )}
        </Button>
      </div>
    </form>
  );
}
